import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private _showEnodeInMenu$ = new ReplaySubject<boolean>(undefined);

  showEnodeInMenu$ = this._showEnodeInMenu$.asObservable();

  constructor() {
    Preferences.get({ key: 'showEnodeInMenu' }).then((res) => {
      if (res.value === 'true') {
        this._showEnodeInMenu$.next(true);
      } else {
        this._showEnodeInMenu$.next(false);
      }
    });
  }

  setShowEnodeInMenu(show: boolean) {
    this._showEnodeInMenu$.next(show);
    Preferences.set({
      key: 'showEnodeInMenu',
      value: show ? 'true' : 'false'
    });
  }
}
